/** Shared workflow types for the script workflow page. */

export type WorkflowStepStatus = 'not_started' | 'in_progress' | 'complete';

export type WorkflowStepKey = 'upload' | 'analyse' | 'generate_scorecard' | 'rebuild';

export type ScriptWorkflowSteps = Record<WorkflowStepKey, WorkflowStepStatus>;

export type ScriptWorkflowState = {
  session_id?: string;
  project_id?: string;
  upload_session_id?: string;
  analysis_session_id?: string;
  rebuild_session_id?: string;
  rebuild_gcs_path?: string;
  script_title?: string;
  gcs_path?: string;
  steps: ScriptWorkflowSteps;
  updated_at?: string;
};

export type WorkflowScriptListItem = ScriptWorkflowState & {
  session_id: string;
  created_at?: string;
  overall_score?: number;
  engagement_percentage?: number;
  mandate_match_pct?: number;
  passes_mandate?: boolean;
  recommendation_label?: string;
};

export const EMPTY_WORKFLOW_STEPS: ScriptWorkflowSteps = {
  upload: 'not_started',
  analyse: 'not_started',
  generate_scorecard: 'not_started',
  rebuild: 'not_started',
};

export function emptyWorkflowState(): ScriptWorkflowState {
  return { steps: { ...EMPTY_WORKFLOW_STEPS } };
}
